import { render, staticRenderFns } from "./BankAccountCreateUpdate.vue?vue&type=template&id=943ce134&"
import script from "./BankAccountCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./BankAccountCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports